import { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { fmt } from "../../lib/api";
import { testProviderLabel } from "../../lib/servers";
import { HeatLayer, HeatLegend, FitBounds } from "../UserHeatMap";

const icon = (bad) => L.divIcon({ className: "", html: `<div class="${bad ? "dot dot-bad" : "dot"}"></div>`, iconSize: [14, 14] });

const Toggle = ({ on, onClick, label, testId }) => (
  <button data-testid={testId} onClick={onClick}
    className={`px-3 py-1.5 text-[11px] border transition-colors ${on ? "bg-[#007AFF] border-[#007AFF] text-white" : "bg-[#121212]/90 border-white/15 text-neutral-400 hover:text-white"}`}>
    {label}
  </button>
);

export const TestMap = ({ tests }) => {
  const [heat, setHeat] = useState(true);
  const [markers, setMarkers] = useState(true);
  const pts = tests.filter((t) => t.location?.lat != null);
  const center = pts.length ? [pts[0].location.lat, pts[0].location.lon] : [-29, 25];
  return (
    <div className="relative h-full w-full" data-testid="test-map">
      <MapContainer key={pts.length} center={center} zoom={pts.length ? 5 : 5} className="h-full w-full" scrollWheelZoom>
        <TileLayer className="dark-tiles" url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        <FitBounds pts={pts.some((t) => t.location.country === "South Africa") ? pts.filter((t) => t.location.country === "South Africa") : pts} />
        {heat && <HeatLayer pts={pts} radius={28} />}
        {markers && pts.map((t) => (
          <Marker key={t.id} position={[t.location.lat, t.location.lon]} icon={icon(t.issues.length > 0)}>
            <Popup>
              <div className="font-mono text-xs">
                <b>{t.rep_name}</b> · {t.team}<br />
                {t.location.city || ""} ({t.location.source})<br />
                ↓{fmt(t.download_mbps)} ↑{fmt(t.upload_mbps)} Mbps · {fmt(t.ping_ms, 0)}ms<br />
                {t.isp || ""}<br />
                Tested via {testProviderLabel(t)}<br />
                {t.issues.map((i) => <div key={i} style={{ color: "#FF3B30" }}>{i}</div>)}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      <div className="absolute top-3 right-3 z-[500] flex gap-1" data-testid="map-layer-toggles">
        <Toggle testId="toggle-coverage-layer" on={heat} onClick={() => setHeat(!heat)} label="Coverage" />
        <Toggle testId="toggle-markers-layer" on={markers} onClick={() => setMarkers(!markers)} label="Test points" />
      </div>
      {heat && <HeatLegend className="absolute bottom-3 left-3 w-56 z-[500] bg-[#121212]/90 border border-white/10 px-3 py-2" />}
    </div>
  );
};
